module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"nl-NL":{"residentialBuilding":"Woonhuis","apartment":"Appartement"}}')
  delete Component.options._Ctor
}
